import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  style: {"position":"relative"}
}

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import alarmLog from '@/assets/svg/nav/alarm-log.svg'
import documentation from '@/assets/svg/nav/documentation.svg'

import electricalPerformance from '@/assets/svg/nav/electrical-performance.svg'
import electricalPerformanceDisabled from '@/assets/svg/nav/electrical-performance-disabled.svg'

import home from '@/assets/svg/nav/home.svg'

import marineSurvey from '@/assets/svg/nav/marine-survey.svg'
import marineSurveyDisabled from '@/assets/svg/nav/marine-survey-disabled.svg'

import mechPhys from '@/assets/svg/nav/mech-phys.svg'
import mechPhysDisabled from '@/assets/svg/nav/mech-phys-disabled.svg'

import spareParts from '@/assets/svg/nav/spare-parts.svg'
import sparePartsDisabled from '@/assets/svg/nav/spare-parts-disabled.svg'

import settings from '@/assets/svg/nav/settings.svg'
import LockIndicator from './LockIndicator.vue'
import ComingIndicator from './ComingIndicator.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavElement',
  props: {
  name: String,
  href: String,
  isExpanded: Boolean,
  disabled: Boolean,
  comingSoon: Boolean,
  hoverandActiveBg: {
    type: String,
    default: '#f5f5f5'
  }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "1d112510": (__props.hoverandActiveBg)
}))

var props = __props

const icon = computed(() => {
  switch (props.name) {
    case 'Alarm Log':
      return alarmLog
    case 'Electrical Performance':
      return props.disabled ? electricalPerformanceDisabled : electricalPerformance
    case 'Mechanical & Physical Data':
      return props.disabled ? mechPhysDisabled : mechPhys
    case 'Marine Survey Data':
      return props.disabled ? marineSurveyDisabled : marineSurvey
    case 'Spare Parts':
      return props.disabled ? sparePartsDisabled : spareParts
    case 'Documentation':
      return documentation
    case 'Home':
      return home
    case 'Administration':
      return settings
    default:
      return ''
  }
})

const route = useRoute()

const active = computed(() => {
  if (props.href === undefined || props.href === '/') {
    return route.path === '/'
  }

  var active = route.path.startsWith('/' + props.href)

  return active
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["nav-item mt-1", __props.isExpanded ? ' justify-content-start' : 'd-flex flex-row justify-content-center'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([[
        'nav-link ms-nav',
        { active: active.value, disabled: __props.disabled },
        __props.isExpanded ? 'justify-content-between' : 'justify-content-center ms-nav-sm'
      ], "d-flex flex-row rounded NKT-P1"]),
      id: 'nav-link-' + __props.name
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: icon.value,
          alt: "",
          class: _normalizeClass(["nav-icon", { expanded: __props.isExpanded }])
        }, null, 10, _hoisted_2),
        _createElementVNode("span", {
          class: _normalizeClass(['ms-nav-text', { expanded: __props.isExpanded }])
        }, _toDisplayString(__props.isExpanded ? __props.name : ''), 3)
      ]),
      (__props.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!__props.comingSoon)
              ? (_openBlock(), _createBlock(LockIndicator, {
                  key: 0,
                  class: "lock-indicator",
                  style: {"position":"absolute"}
                }))
              : (_openBlock(), _createBlock(ComingIndicator, {
                  key: 1,
                  "is-expanded": __props.isExpanded,
                  class: "lock-indicator",
                  style: {"position":"absolute"}
                }, null, 8, ["is-expanded"]))
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_1)
  ], 2))
}
}

})